import { Alert, Checked } from "@otp/icons";

export const RestaurantStatus = ({
  isNeedAttention,
}: {
  isNeedAttention: boolean;
}) => {
  return isNeedAttention ? <Alert /> : <Checked />;
};
